<mat-sidenav-container
  class="!fixed bottom-0 left-0 right-0 top-16 !z-10 h-[calc(100dvh-4rem)] w-screen !bg-transparent text-[#1E1E1E] md:!hidden"
  [ngClass]="[sidenav().opened ? '' : 'pointer-events-none hidden']"
>
  <mat-sidenav class="z-10 w-full" mode="over">
    <ng-container
      *ngTemplateOutlet="
        mainmenuRef;
        context: { items: menu(), parentDrawer: sidenav() }
      "
    />
  </mat-sidenav>
</mat-sidenav-container>

<ng-template #mainmenuRef let-items="items" let-parentDrawer="parentDrawer">
  <sheba-drawer #drawer>
    <div class="flex-1 overflow-y-auto">
      <div
        class="flex h-full flex-col gap-8 bg-gradient-to-bl from-white to-[#FCF5F9] py-7"
      >
        <div class="flex flex-col">
          @for (item of items; track $index) {
            @if (item.children) {
              <button
                (click)="
                  drawer.open(menuRef, {
                    items: item.children,
                    parentDrawer: drawer,
                    title: item.text
                  })
                "
                shMenuItem
              >
                {{ item.text }}
              </button>
            }
          }
        </div>

        <div class="my-auto flex place-content-center gap-3">
          @for (lang of languageService.languagesList(); track $index) {
            <button class="rounded" matRipple (click)="languageService.setLanguage(lang)">
              <span class="px-2 text-xl leading-6">{{lang.name}}</span>
              @if (languageService.currentLanguage().isoCode === lang.isoCode) {
                <div class="mx-2 border-b border-[#1E1E1E]"></div>
              }
            </button>
          }
        </div>

        <sheba-footer-links 
        [termsOfUseLink]="termsOfUseLink()" 
        [sitesPolicyLink]="sitesPolicyLink()"
        [allRightsReservedLink]="allRightsReservedLink()"
        [accessibilityStatementLink]="accessibilityStatementLink()" />
      </div>
    </div>
  </sheba-drawer>
</ng-template>

<ng-template
  #menuRef
  let-items="items"
  let-parentDrawer="parentDrawer"
  let-title="title"
  let-templateRef="templateRef"
>
  <sheba-drawer #drawer>
    <div class="flex-1 overflow-y-auto">
      <div
        class="flex h-full flex-col bg-gradient-to-bl from-white to-[#FCF5F9] py-7"
      >
        <button
          class="mb-3 flex place-content-start gap-2 px-4 py-2 text-[0.938rem] leading-[1.125rem] hover:bg-gray-200"
          (click)="parentDrawer.close()"
          matRipple
        >
          <span class="h-[1.125rem]"><</span>
          <span >{{'SIDENAV.BACK_TO_THE_MAIN_MENU' | translate}}</span>
        </button>

        <span class="px-4 py-3 text-xl font-bold text-[#161F72]">{{
          title
        }}</span>

        @for (item of items; track $index) {
          @if (item.children) {
            <button
              (click)="
                drawer.open(submenuRef, {
                  items: item.children,
                  parentDrawer: drawer,
                  title: item.text
                })
              "
              shMenuItem
            >
              {{ item.text }}
            </button>
          }
        }
      </div>
    </div>
  </sheba-drawer>
</ng-template>

<ng-template
  #submenuRef
  let-items="items"
  let-parentDrawer="parentDrawer"
  let-title="title"
>
  <sheba-drawer #drawer>
    <div class="flex-1 overflow-y-auto">
      <div
        class="flex h-full flex-col bg-gradient-to-bl from-white to-[#FCF5F9] py-7"
      >
        <button
          class="mb-3 flex place-content-start gap-2 px-4 py-2 text-[0.938rem] leading-[1.125rem] hover:bg-gray-200"
          (click)="parentDrawer.close()"
          matRipple
        >
          <span class="h-[1.125rem]"><</span>
          <span >{{'SIDENAV.BACK_TO' | translate }}{{title}}</span>
        </button>

        <span class="px-4 py-3 text-xl font-bold text-[#161F72]">{{
          title
        }}</span>

        @for (item of items; track $index) {
          <a class="hover:bg-gray-200" 
          [href]="item.link?.url ?? item.link?.route?.path"
          [attr.target]="item.link?.target"
          [title]="item.text"
          routerLinkDetector
          (click)="closeAll()"
          matRipple>
            <span class="flex place-content-between px-4 py-4 text-base">{{
              item.text
            }}</span>
            <div class="mx-4 border-b border-[#D3D8EF] opacity-50"></div>
          </a>
        }
      </div>
    </div>
  </sheba-drawer>
</ng-template>
